/**
 * "Contas a pagar" section copy (one group per domain; the AR domain adds `ar-section.ts`). The
 * rows are advisory; a checklist task embedded in a row (e.g. "Provisões em aberto" under AP05)
 * keeps its own required status, so the subtitle never says the section cannot block the close.
 */
export const apSectionPtBr = {
  title: 'Contas a pagar',
  subtitle:
    'Controles consultivos, fora do progresso do checklist. Tarefas exibidas aqui, como Provisões em aberto, continuam obrigatórias para o fechamento.',
};

export const apSectionEn: typeof apSectionPtBr = {
  title: 'Accounts payable',
  subtitle:
    'Advisory controls, outside the checklist progress. Tasks shown here, such as Open accruals, are still required to close.',
};
